/* eslint-disable camelcase */

import { fetch } from '../utils/request';

const getUrl = (path) => `${process.env.MONO_API}${path}`;

export default {
  getPartners() {
    return fetch(getUrl('/partners'), { skipAuthRedirect: true });
  },

  getExperience(partner, id) {
    return fetch(getUrl(`/partners/${partner}/experiences/${id}`), { skipAuthRedirect: true });
  },
  getFoxForesightCharts: () => fetch(getUrl('/partners/sportsgold/charts'), { skipAuthRedirect: true }),
  getFoxForesightGames: (date, sport) => {
    const params = new URLSearchParams({ day: date });
    if (sport) {
      params.append('sport', sport);
    }

    return fetch(getUrl(`/partners/sportsgold/games?${params.toString()}`), { skipAuthRedirect: true });
  },
  getFoxForesightChartOptions: (chartType, gameId) => fetch(getUrl(`/partners/sportsgold/charts/${chartType}/options?game_id=${gameId}`), { skipAuthRedirect: true }),
};
